/**
 * Helper for triggering events before and after a promise resolves
 * @module lib/withEvents
 */

/**
 * Trigger events on the given `scope` before and after the given promise. The events will be named:
 *  - `<eventName>:before` for the event before the promise
 *  - `<eventName>:after` for the event after the promise
 * @param {Promise} promise
 * @param {Object} options
 * @param {HTMLElement} options.scope - The element on which to trigger the event
 * @param {string} options.eventName - The name used as base for the event names
 */
export default function withEvents(promise, { scope, eventName }) {
  const event = new CustomEvent(`${eventName}:before`, { bubbles: true });
  scope.dispatchEvent(event);
  return promise.finally(() => {
    const event = new CustomEvent(`${eventName}:complete`, { bubbles: true });
    scope.dispatchEvent(event);
  });
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/withEvents.js